var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from "lit";
import { PIC, PICBase, customElement, doSubmit } from "../Internals";
import { property } from "lit/decorators.js";
import { loginMSALPopup } from "../../util/auth/SSO";
let PICLogin = class PICLogin extends PICBase {
    constructor() {
        super(...arguments);
        /* default all to false, so they have to specifically be set when used */
        this.showLoginSystems = false;
        this.showHasAgreement = false;
        this.ssoType = 'saml';
    }
    static get styles() {
        return css `
			:host {
				width: 100%;
				height: 100%;
				display: grid;
				/* position: fixed; */
				place-items: center;
			}
			.bg {
				background-size: cover;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.bg-overlay {
				height: 100%;
				width: 100%;
				/* Wash the bg image toward the current theme's page background
				   (white in light, near-black in dark) rather than always
				   lightening it - a fixed white wash would read as brighter
				   than the card itself in dark mode. */
				background-color: rgba(var(--pic-backgroundColorRGB, 255, 255, 255), 0.4);
			}
			.container {
				/* border: 1px solid black; */
				display: flex;
				flex-flow: column;
				align-items: center;
				position: fixed;
				/* height: 640px; */
				width: 400px;
				place-content: center;
				background: var(--pic-surfaceColor, white);
				padding-bottom: 3%;
				padding-top: 3%;
				border-radius: 2%;
				box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
			}
			/* for the fallback version */
			slot > * { 
				width: 80% !important;
				max-width: unset !important;
			}
			#logoImg {
				width: 80%;
				height: 20%;
				object-fit: cover;
				margin: 0 0 5% 0;
			}
			#loginBtn {
				margin-top: 10%;
			}
			pic-button {
				margin-bottom: 2%;
			}
			#systemName {
				margin-bottom: 3%;
			}
			/* For the slotted version */
			::slotted(*) {
				width: 80% !important;
				max-width: unset !important;
			}
			::slotted(pic-image) {
				margin: 0 0 5% 0;
			}
			::slotted(pic-button) {
				margin-bottom: 2%;
			}
		`;
    }
    renderLoginSystems() {
        return html `<pic-suggestion id="location" label="Select login system" density="medium" etype="default"></pic-suggestion>`;
    }
    loginSSO() {
        loginMSALPopup(PIC.getInstance.msal).then(loginResponse => {
            var _a;
            console.log('loginResponse', loginResponse);
            if (!loginResponse)
                return; //Error handling
            const PICForm = document.querySelector('#PICForm');
            if (!PICForm)
                return;
            const ssoFld = (_a = PICForm.querySelector('input[name="sso"]')) !== null && _a !== void 0 ? _a : document.createElement('input');
            ssoFld.type = 'hidden';
            ssoFld.name = 'sso';
            ssoFld.value = JSON.stringify(loginResponse);
            PICForm.appendChild(ssoFld);
            doSubmit('doSSOOIDC', { force: true });
        });
    }
    renderFallbackPage() {
        //focus/submit should work with ?submit=${true}, but it doesn't - therefore submit="true"
        return html `
			<pic-image id="logoImg" src=${this.logoSrc} width="100%25" height="100%25"></pic-image>
			${this.systemName ? html `<pic-label id="systemName" label=${this.systemName} etype="default" justification="center" density="medium" size="2"></pic-label>` : nothing}
			<pic-text id="usr" autocomplete="off" label="Username" density="medium" etype="default" placeholder="" focus="true"></pic-text>
			<pic-password id="pwd" label="Password" density="medium" etype="default" placeholder=""></pic-password>
			${this.showLoginSystems ? this.renderLoginSystems() : nothing}
			
			<pic-button id="loginBtn" label="LOGIN" event="doLogin" density="low" etype="contained" submit="true"></pic-button>
			${this.showSingleSignOn && this.ssoType === 'oidc'
            ? html `<pic-button id="ssoBtn" eventstyle="js" @jsclick=${this.loginSSO} label="Login with SSO" density="low" etype="contained"></pic-button>`
            : this.showSingleSignOn
                ? html `<pic-button id="ssoBtn" event="doSSO" label="Login with SSO" density="low" etype="contained"></pic-button>`
                : nothing}
			${this.showNoAgreement ? html `<pic-button id="noAgrBtn" event="doNoAgr" label="I Have No Agreement" density="low" etype="contained"></pic-button>` : nothing}
			${this.showHasAgreement ? html `<pic-button id="hasAgrBtn" event="doHasAgr" label="Login with agreement Id" density="low" etype="contained"></pic-button>` : nothing}
		`;
    }
    render() {
        /* if premadeRender is used then the TemplateResult above is used
            else a default slot element will eat all the elements inside.
            If no children in slot then fallback is rendered (has be empty textContent, no whitespace allowed)
        */
        return html `
		<div class="bg" style="background-image: url(${this.bgSrc});">
			<div class="bg-overlay"></div>
			<div class="container">
				<slot>${this.renderFallbackPage()}</slot>
			</div>
		</div>

		`;
    }
};
__decorate([
    property()
], PICLogin.prototype, "bgSrc", void 0);
__decorate([
    property()
], PICLogin.prototype, "logoSrc", void 0);
__decorate([
    property()
], PICLogin.prototype, "systemName", void 0);
__decorate([
    property()
], PICLogin.prototype, "loginSystems", void 0);
__decorate([
    property({ type: Boolean })
], PICLogin.prototype, "showLoginSystems", void 0);
__decorate([
    property({ type: Boolean })
], PICLogin.prototype, "showNoAgreement", void 0);
__decorate([
    property({ type: Boolean })
], PICLogin.prototype, "showHasAgreement", void 0);
__decorate([
    property({ type: Boolean })
], PICLogin.prototype, "showSingleSignOn", void 0);
__decorate([
    property({ type: String })
], PICLogin.prototype, "ssoType", void 0);
PICLogin = __decorate([
    customElement('pic-login')
], PICLogin);
export { PICLogin };
//# sourceMappingURL=PICLogin.js.map